import { ThemeContextType, createTheme } from '../utils';
import * as PriceMatrixStyles from './components/PriceMatrix.css';
import * as MatrixStyles from './components/Matrix/Matrix.css';
import * as OutboundStyles from './components/Outbound/Outbound.css';

export const defaultTheme = {
	PriceMatrixStyles,
	MatrixStyles,
	OutboundStyles
};

export interface WithThemeProps {
	theme: ThemeContextType<typeof defaultTheme>;
}

export const { Provider, withTheme } = createTheme<typeof defaultTheme>(defaultTheme);
